import React from "react";
import { Typography, Button, Grid } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import LoginContainer from "../LoginContainer";
import { styles } from '../styles';


const Success = (props) => {
    const classes = styles();
    const acceptBtn = (e) => {
        e.preventDefault();
        props.history.push("/auth/validate");
    };

    const messageSucces = () => (
        <Grid container spacing={0} className="container">
             <Grid>
              <div  className="mt10">
                    <Typography
                       className = { classes.fontSize14  }
                       style = {{ marginBottom: '15%' }}
                    >
                       Le fue enviado un correo electrónico para cambio de contraseña, 
                       verifique por favor.
                    </Typography>
                    <Typography
                        className = { classes.fontSize14 }
                    >
                     Si no llega o no funciona el correo electrónico, solicite el reenvío.
                    </Typography>
                    <Grid container spacing={1} style={{justifyContent: 'center', margin: '8% 0px 20% 0px'}}>
                        <Grid item xs={12} sm={12} md={6}> 
                            <Button
                                type="submit"
                                variant="contained"
                                onClick = { acceptBtn }
                                className = { classes.submit }
                                disableElevation
                            >
                                Reenviar
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <Button
                                type="submit"
                                variant="contained"
                                className = { classes.buttonBack }
                                onClick = { () => props.history.push('/auth/login') }
                                disableElevation
                            >
                                Regresar
                            </Button>
                        </Grid>
                    </Grid>
                    </div>
                </Grid>
            </Grid>
    )

    return(
        <LoginContainer>
          { messageSucces() }
        </LoginContainer> 
      )
   
};

export default withRouter(Success);
